var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.maxlength)?_c('div',{class:( _obj = {}, _obj[_vm.char_left_class] = true, _obj ),staticStyle:{"text-align":"right","margin-top":"5px","margin-bottom":"10px","float":"right"},style:({ color: _vm.char_left_class })},[_vm._v(" "+_vm._s(_vm.char_left)+" "+_vm._s(_vm.__("char remaining", "tmbooking"))+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }